import React, { Component } from "react"
import { connect } from "react-redux"
import ProjectItem from "./Projects/ProjectItem"
import Pagination from "../UI/Pagination"
import { getProjects } from "../../store/actions"
import Spinner from "../UI/Spinner"
import Button from "../UI/button/Button"
import Modal from "../UI/Modal"
import CenteredContainer from "../UI/container/CenteredContainer"
import AddToReel from "./AddToReel/AddToReel"
import { withRouter } from "react-router-dom"

class ProjectItems extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showModal: false,
      checkFalse: !this.props.projects.loading,
      isChecked: false,
      selectedReels: [],
    }
  }

  componentDidMount() {
    // Read query params from URL on mount
    const urlParams = new URLSearchParams(this.props.location.search)
    const searchParams = Object.fromEntries(urlParams.entries())

    // Default to page=1 if not provided
    if (!searchParams.page) searchParams.page = "1"

    this.props.getProjects(searchParams)
  }

  openModal = () => {
    window.scrollTo(0, 0)
    this.setState({ showModal: true })
  }

  paginationHandler = (page) => {
    window.scrollTo(0, 0)
    this.setState({ checkFalse: null })

    // Read current URL params
    const urlParams = new URLSearchParams(this.props.location.search)
    const searchParams = Object.fromEntries(urlParams.entries())

    // Update page number
    const newPage = page.selected + 1
    searchParams.page = newPage.toString()

    // Update the browser URL
    const query = new URLSearchParams(searchParams).toString()
    this.props.history.push(`/projects?${query}`)

    // Fetch new page
    this.props.getProjects(searchParams)
  }

  selectedReelsHandler = (projectId, isChecked) => {
    const selectedReels = [...this.state.selectedReels]
    if (isChecked) {
      selectedReels.push(projectId)
      this.setState({ selectedReels })
    } else {
      const index = selectedReels.indexOf(projectId)
      if (index !== -1) {
        selectedReels.splice(index, 1)
        this.setState({ selectedReels })
      }
    }
  }

  clearCheckboxHandler = () => {
    this.setState({ selectedReels: [] })
  }

  render() {
    const { projects, totalCount } = this.props.projects
    const { loading } = this.props.response
    let projectItems

    // Determine active page from URL
    const urlParams = new URLSearchParams(this.props.location.search)
    const currentPage = parseInt(urlParams.get("page") || "1", 10)
    const forcePage = currentPage > 0 ? currentPage - 1 : 0

    if (projects === null || loading) {
      projectItems = <Spinner />
    } else if (projects.length > 0) {
      projectItems = projects.map((project) => (
        <ProjectItem
          key={project.id}
          project={project}
          isChecked={
            project.has_video
              ? this.state.selectedReels.indexOf(project.id) !== -1
              : false
          }
          clicked={this.selectedReelsHandler}
          showReels={this.props.showReels}
        />
      ))
    } else {
      projectItems = (
        <CenteredContainer>
          <h4 className="center-block">No projects found...</h4>
        </CenteredContainer>
      )
    }

    return (
      <div className="border-left">
        <div className="p-4">
          <div className="row">
            <div className="col-6 py-2">
              <span>
                Total Projects:{" "}
                <span className="font-weight-bold">{totalCount}</span>
              </span>
            </div>
            {this.props.showReels ? (
              <div className="col-6 text-right">
                <Button
                  type="success"
                  clicked={
                    this.props.canViewAddProjects ? this.openModal : null
                  }
                  disabled={
                    !(
                      this.state.selectedReels.length ||
                      !this.props.canViewAddProjects
                    )
                  }
                  style={{
                    cursor: this.props.canViewAddProjects
                      ? "pointer"
                      : "no-drop",
                    opacity: this.props.canViewAddProjects ? 1 : 0.7,
                  }}
                >
                  Add to Reel
                </Button>
              </div>
            ) : null}
          </div>
        </div>

        <ul className="list-group list-group-flush">{projectItems}</ul>

        <Pagination
          forcePage={forcePage}
          pageCount={Math.ceil(totalCount / 10)}
          handlePageClick={this.paginationHandler}
          checkFalse={this.state.checkFalse}
          range={5}
        />

        <Modal
          title="Add to Reel"
          show={this.state.showModal}
          hide={() => this.setState({ showModal: false })}
          style={{ top: "15%" }}
          flag={true}
        >
          <AddToReel
            closeModal={() => this.setState({ showModal: false })}
            selectedReels={this.state.selectedReels}
            clearCheckbox={this.clearCheckboxHandler}
          />
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  projects: state.projects,
  response: state.response,
})

export default withRouter(connect(mapStateToProps, { getProjects })(ProjectItems))
